<!-- this div will be used to anchor all page content -->
<!-- in print mode it will go to the lowest of the page-->
<!--

                marginTop: "5cm",
                marginRight: "1.5cm",
                marginBottom: "1.5cm",
                marginLeft: "1.5cm",

                1cm == 37.7952755906px
-->
<!-- The cover page gets it's own rendering process for the fixed display in the lowest-point class -->
<div class="one-page-height">
    <div class="lowest-point">
        <h1 *ngIf="showAdjustmentInSums" class="intern-text">{{ 'aumico_cover_page_internal_label' | i18next}}</h1>
        <h2 *ngIf="draftLabel" class="draft-label">{{ draftLabel | i18nextWithLocale: reportLocale }}</h2>
        <h1 class="title" stylePreference [textColor]="textColor">
            {{ reportTitlePart1 }}

            <br />
            <span class="title colored-title" stylePreference [textColor]="titleColor">{{ reportTitlePart2 }}</span>
            <br />
            <span class="title colored-title" stylePreference [textColor]="titleColor">{{ reportTitlePart3 }}</span>
        </h1>

        <div class="below-title"></div>
        <div class="horizontal-separator"></div>

        <div class="below-separator"></div>

        <div class="details" stylePreference [textColor]="textColor">{{ companyName }}</div>
        <div class="details" stylePreference [textColor]="textColor">{{ companyAdditionToAddress }}</div>
        <div class="details" stylePreference [textColor]="textColor">{{ companyStreet }}</div>
        <div class="details" stylePreference [textColor]="textColor">
            {{ companyZip }}{{ companyZip && ' ' }}{{ companyCity }}
        </div>
        <div class="details" stylePreference [textColor]="textColor">{{ companyUID }}</div>

        <div class="date" stylePreference [textColor]="textColor">{{ signaturePlaceDate }}</div>

        <div class="below-details-margin"></div>
        <div class="under-place-margin"></div>
    </div>
</div>
